import { CompareUtil } from "@base/util/CompareUtil";

export function getChecked<T>(params: {
  selection: T;
  validItems: readonly T[];
  emptySelection: "__selectionRequired__" | T | undefined;
  isEqual?: (a: T, b: T) => boolean;
}): T | undefined {
  const { selection, validItems, emptySelection } = params;
  if (validItems.length === 0)
    return emptySelection !== "__selectionRequired__" ? emptySelection : undefined;

  if (!selection && emptySelection !== "__selectionRequired__")
    return emptySelection;


  const eq = params?.isEqual ?? CompareUtil.refEqual
  if (validItems.findIndex((item) => eq(item, selection || "__undefined__" as any)) !== -1)
    return selection;

  if (emptySelection && emptySelection !== "__selectionRequired__" && validItems.findIndex((item) => eq(item, emptySelection)) !== -1) // GroundPlate
    return emptySelection;

  return validItems[0];
}